import { ArrowRightUpIcon } from "@cynthai/icons";
import { Card, Chip, Link } from "@cynthai/ui";

import { useIncrementArticleViews } from "@/features/help-center/hooks/use-articles";
import { getMediaUrl } from "@/features/help-center/hooks/use-media-uploads";
import type { ArticleResponse } from "@/openapi/types.gen";
import { m } from "@/paraglide/messages";

function stripHeading(md: string) {
  return md.trim().replace(/^#{1,6}\s*/, "");
}

export default function ArticleCard({
  article,
}: Readonly<{ article: ArticleResponse }>) {
  const incrementView = useIncrementArticleViews();
  const handleIncrementView = () => {
    incrementView.mutate({ path: { article_id: article.id } });
  };

  return (
    <Card
      className={`bg-tertiary dark:bg-background-2 p-8 transition-shadow hover:shadow-lg`}
    >
      {article.thumbnail_id && getMediaUrl(article.thumbnail_id) ? (
        <img
          src={getMediaUrl(article.thumbnail_id)}
          alt={article.title}
          className="mb-3 h-40 w-full rounded-md object-cover"
          aria-hidden="true"
        />
      ) : (
        <div
          aria-hidden="true"
          className="mb-3 h-40 w-full rounded-md bg-gray-800"
        />
      )}
      <div className="space-y-2">
        <div className="my-4 mb-2 flex flex-wrap gap-2">
          {article.topics?.map((topic) => (
            <Chip
              key={topic.id}
              size="sm"
              className={`text-text-tertiary cursor-pointer rounded-md border bg-transparent px-2 py-1 text-xs`}
            >
              {topic.name}
            </Chip>
          ))}
        </div>

        <h3 className="text-text-primary py-2 text-lg font-semibold">
          {stripHeading(article.title)}
        </h3>
        {article.excerpt && (
          <p className="text-text-secondary text-sm">
            {stripHeading(article.excerpt)}
          </p>
        )}
        <div
          className={`text-primary mt-6 flex items-center gap-2 text-sm font-medium`}
        >
          <Link
            onClick={handleIncrementView}
            to="/help-center/articles/$id"
            params={{ id: article.id }}
            size="sm"
            color="primary"
          >
            {m.view_article()}{" "}
            <ArrowRightUpIcon
              height={12}
              width={12}
              className="text-primary -mt-0.5 ml-1 inline-block"
            />
          </Link>
        </div>
      </div>
    </Card>
  );
}
